'use strict';

module.exports = {
    contentful: {
        previewHost: 'preview.contentful.com',
        productionHost: window.location.hostname,
        space: 'pasba798pw1y',
        previewKey: '1a7aac1267f3ea392b4d07487b844b78f1b0d7c7402fbf1eb8a78964392a530e',
        productionKey: '2b39e9eb17362e497fe29e2173450d5b81689d8d314a51cf3a8482bc81335c33'
    }
};
